import inView from 'in-view';

export default function video() {
  $('.wp-block-video').each(function () {
    const video = $(this).find('video');
    const $hover = $(this).find('.wp-block-video__hover');

    if ($hover.length) {
      video.on('play', function () {
        $hover.fadeOut();
      });
      $hover.on('click', function () {
        video.get(0).play();
      });
    }

    if (video.attr('data-autoplay')) {
      const id =
        video.attr('id') ||
        `in-view-${Math.random().toString(36).substr(2, 9)}`;
      video.attr('id', id);

      const selector = `#${id}`;

      inView(selector).once('enter', function (el) {
        setTimeout(function () {
          video.get(0).play();
        }, 1000);
      });
    }
  });
}
